export default __webpack_public_path__ + "static/media/03_Pair.c66c7375.png";